import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  sales: [],
  maps: [],
  lot: [],
  lots: [],
  clients: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalSales: 0,
    totalPages: 0
  },
  salesCatalog: {},
  categoriesCatalog: [],
  filterParams: '',
  isModalVisible: false,
  isModalImagesVisible: false
}

const mutations = {
  SET_SALES (state, payload) {
    state.sales = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalSales: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_CATEGORIES_CATALOG (state, payload) {
    state.categoriesCatalog = payload
  },
  SET_MAPS (state, payload) {
    state.maps = payload
  },
  SET_LOT (state, payload) {
    state.lot = payload
  },
  SET_LOTS (state, payload) {
    state.lots = payload
  },
  SET_CLIENTS (state, payload) {
    state.clients = payload
  },
  ADD_SALE (state, payload) {
    state.sales.unshift(payload)
  },
  UPDATE_SALE (state, payload) {
    const idx = state.sales.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.sales, idx, payload)
    }
  },
  DELETE_SALE (state, payload) {
    const idx = state.sales.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.sales, idx)
    }
  },
  DELETE_SALES (state, payload) {
    for (let id of payload.ids) {
      const idx = state.sales.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.sales, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_IMAGES_VISIBLE (state, payload) {
    state.isModalImagesVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.salesCatalog[object] = payload.data
  },
  SET_SALES_CATALOG (state, payload) {
    state.salesCatalog = { ...state.salesCatalog, ...payload }
  }
}

const actions = {
  async loadSales ({ commit }, payload) {
    if (!payload.map_id) {
      payload.map_id = 1
    }
    app.$Progress.start()
    try {
      const response = await axios.get(
        `sales?page=${payload.page}${state.filterParams}`
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_SALES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadClients ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`clients/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_CLIENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadLots ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`sales/all/${payload.map_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_LOTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadMaps ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`maps/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_MAPS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCategoriesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`categories/all`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_CATEGORIES_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async addSale ({ commit }, payload) {
    const sale = {
      // columnas
      // sku: payload.sku,
    }

    app.$Progress.start()

    try {
      const response = await axios.post('sales', sale)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('ADD_SALE', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: 'front.added_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async editSale ({ commit }, payload) {
    const sale = {
      id: payload.id,
      layer_id: payload.layer_id,
      title: payload.title,
      about: payload.about,
      description: payload.description,
      category: payload.category,
      link: payload.link,
      fill: payload.fill,
      x: payload.x,
      y: payload.y,
      zoom: parseInt(payload.zoom),
      status: parseInt(payload.status),
      map_id: parseInt(payload.map_id)
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`sales/${payload.id}`, sale)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('UPDATE_SALE', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: 'front.updated_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteSaleImage ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`sale-image/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: 'front.deleted_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteSale ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`sales/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('DELETE_SALE', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: 'front.deleted_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteSales ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`sales/delete`, {
        params: { ids: payload.ids }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('DELETE_SALES', payload)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: 'front.deleted_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async actionSale ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(
        `sales/${payload.id}/${payload.action}`
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('UPDATE_SALE', response.data)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: `sales.${payload.action}`,
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async changeLot ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(
        `sales/${payload.id}/change`,
        payload
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('UPDATE_SALE', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: `sales.update`,
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/sales/export?format=csv' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_CATALOG', {
          object: payload.url,
          payload: response.data
        })
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async loadSalesCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`sales/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'strings.sales',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_SALES_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalImagesVisible ({ commit }, payload) {
    commit('SET_MODAL_IMAGES_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  sales: state => state.sales,
  maps: state => state.maps,
  lots: state => state.lots,
  clients: state => state.clients,
  salesCatalog: state => state.salesCatalog,
  categoriesCatalog: state => state.categoriesCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalImagesVisible: state => state.isModalImagesVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
